import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export function TransferDialog({
  open, onOpenChange, ticket, categories, counters, currentCounterId, onConfirm, busy,
}) {
  const [mode, setMode] = useState("category");
  const [target, setTarget] = useState("");
  const [reason, setReason] = useState("");

  const reset = () => { setMode("category"); setTarget(""); setReason(""); };
  const handleOpenChange = (v) => { if (!v) reset(); onOpenChange(v); };

  const confirm = async () => {
    if (!target) return;
    await onConfirm({ mode, target, reason: reason.trim() });
    reset();
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Transférer le ticket {ticket?.full_ticket_code}</DialogTitle>
          <DialogDescription>
            Le ticket conserve son numéro et retourne dans la file d'attente.
          </DialogDescription>
        </DialogHeader>
        <div className="py-2 space-y-3">
          <Tabs value={mode} onValueChange={(v) => { setMode(v); setTarget(""); }}>
            <TabsList className="grid grid-cols-2">
              <TabsTrigger value="category" data-testid="transfer-mode-category">Vers une catégorie</TabsTrigger>
              <TabsTrigger value="counter" data-testid="transfer-mode-counter">Vers un guichet</TabsTrigger>
            </TabsList>
            <TabsContent value="category" className="pt-3">
              <Label className="text-sm">Nouvelle catégorie</Label>
              <Select value={target} onValueChange={setTarget}>
                <SelectTrigger data-testid="transfer-target-category">
                  <SelectValue placeholder="Sélectionnez une catégorie" />
                </SelectTrigger>
                <SelectContent>
                  {categories.filter((c) => c.code !== ticket?.category_code).map((c) => (
                    <SelectItem key={c.id} value={c.code}>
                      <span className="font-mono font-bold mr-2" style={{ color: c.color }}>{c.code}</span> {c.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </TabsContent>
            <TabsContent value="counter" className="pt-3">
              <Label className="text-sm">Guichet destinataire</Label>
              <Select value={target} onValueChange={setTarget}>
                <SelectTrigger data-testid="transfer-target-counter">
                  <SelectValue placeholder="Sélectionnez un guichet" />
                </SelectTrigger>
                <SelectContent>
                  {counters.filter((c) => c.id !== currentCounterId).map((c) => (
                    <SelectItem key={c.id} value={c.id}>{c.counter_name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </TabsContent>
          </Tabs>
          <div>
            <Label className="text-sm">Motif (optionnel)</Label>
            <Textarea value={reason} onChange={(e) => setReason(e.target.value)}
              placeholder="Ex: dossier de sinistre, mauvaise file…" rows={2} data-testid="transfer-reason" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => handleOpenChange(false)}>Annuler</Button>
          <Button onClick={confirm} disabled={!target || busy}
            className="bg-[#DC2626] hover:bg-[#B91C1C]" data-testid="transfer-confirm">
            Transférer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
